// extracted by mini-css-extract-plugin
export var content = "text-section-with-title-on-left-physiolymp-module--content--doN9f";
export var section = "text-section-with-title-on-left-physiolymp-module--section--K-pLF";
export var subtitle = "text-section-with-title-on-left-physiolymp-module--subtitle--2jHuL";
export var title = "text-section-with-title-on-left-physiolymp-module--title--DQg8m";